exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".skill-icon {\r\n  font-size: 4em;\r\n  padding: 0 !important;\r\n  color: #fff\r\n}\r\n\r\n.skill-icon:hover {\r\n  text-shadow: 3px 3px 0px rgba(255, 255, 255, 0.5);\r\n}\r\n\r\n.skills-list {\r\n  margin-left: 20px;\r\n}\r\n\r\n.skills-list > p {\r\n  font-size: .85em;\r\n  font-weight: 600;\r\n  padding: 0;\r\n  margin-bottom: 10px;\r\n  color: rgba(255, 255, 255, 0.7);\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// F:/Home/Locker/About-me/about-me1/src/app/displayer/skills-section/skills-section.component.css
// module id = ../../../../../src/app/displayer/skills-section/skills-section.component.css
// module chunks = main